/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it

import React from "react"
import "./src/assets/scss/tailwind.scss"
import { ThemeProvider } from "./src/context/ThemeContext"
import { AuthProvider } from "./src/context/AuthContext"

export const wrapRootElement = ({ element }) => (
  // <AuthProvider>
  //   <ThemeProvider>{element}</ThemeProvider>
  // </AuthProvider>
  <ThemeProvider>{element}</ThemeProvider>

)
